import { I18n } from 'react-redux-i18n-lite';
import * as groupsApi from '../../../services/api/groupApi';

let getGroup = (id, name, isEveryOne) => {
  return {
    id: id,
    name: name,
    isGroup: true,
    isEveryone: isEveryOne
  };
};

export let getStudent = id => {
  return {
    id: id,
    isGroup: false,
    isEveryone: false
  };
};

export let getGroupWithId = (groupId, groups) => {
  let groupRes = getGroup(0, I18n.t('lessonCard.everyone'), true);
  if (groups) {
    groups.forEach(group => {
      if (group.id === groupId) {
        groupRes = getGroup(group.id, groupsApi.getGroupName(group), false);
      }
    });
  }
  return groupRes;
};
